import styled from 'styled-components';
import { colorPrimary } from '../../theme';

/* ===== WRAPPER ===== */
export const Wrapper = styled.div`
	font-family: 'Poppins', sans-serif;
	color: #333;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
`;

export const Container = styled.div`
	max-width: 1170px;
	margin: 0 auto;
	padding: 0 15px;
	width: 100%;
	box-sizing: border-box;
`;

/* ===== LANGUAGE STRIP ===== */
export const LanguageStrip = styled.div`
	background: #222;
	padding: 6px 0;

	ul {
		list-style: none;
		margin: 0;
		padding: 0;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		gap: 10px;
	}

	img {
		width: 25px;
		height: auto;
		cursor: pointer;
		opacity: 0.7;
		transition: opacity 0.2s;
		margin-top: -2px;

		&:hover,
		&.active {
			opacity: 1;
		}
	}
`;

/* ===== HEADER ===== */
export const HeaderBar = styled.header`
	background: #292929;
	padding: 12px 0;

	@media (max-width: 991px) {
		padding: 10px 0;
	}
`;

export const HeaderInner = styled.div`
	max-width: 1170px;
	margin: 0 auto;
	padding: 0 15px;
	display: flex;
	align-items: center;
	justify-content: space-between;

	@media (max-width: 991px) {
		flex-direction: column;
		gap: 12px;
	}
`;

export const Logo = styled.a`
	display: inline-block;

	img {
		max-height: 55px;
		display: block;
	}
`;

export const NavMenu = styled.nav`
	ul {
		list-style: none;
		margin: 0;
		padding: 0;
		display: flex;
		gap: 0;
	}

	li a {
		display: inline-block;
		padding: 10px 16px;
		color: #fff;
		text-decoration: none;
		font-size: 13px;
		font-weight: 500;
		text-transform: uppercase;
		letter-spacing: 0.5px;
		transition: color 0.25s;

		i {
			margin-right: 5px;
		}

		&:hover {
			color: ${colorPrimary};
		}
	}

	@media (max-width: 991px) {
		ul {
			flex-wrap: wrap;
			justify-content: center;
		}
		li a {
			padding: 6px 10px;
			font-size: 12px;
		}
	}
`;

/* ===== SHARED FORM ===== */
export const FormGroup = styled.div`
	width: 100%;
`;

export const FormInput = styled.input`
	width: 100%;
	padding: 12px 16px;
	border: 1px solid #ddd;
	border-radius: 4px;
	font-size: 14px;
	font-family: 'Poppins', sans-serif;
	color: #333;
	outline: none;
	transition: border-color 0.25s;
	box-sizing: border-box;

	&::placeholder {
		color: #aaa;
	}

	&:focus {
		border-color: ${colorPrimary};
	}

	&:disabled {
		background: #f9f9f9;
		cursor: not-allowed;
	}
`;

export const BtnFull = styled.button`
	display: block;
	width: 100%;
	padding: 12px;
	background: ${colorPrimary};
	color: #fff;
	border: none;
	border-radius: 4px;
	font-size: 14px;
	font-weight: 600;
	font-family: 'Poppins', sans-serif;
	text-transform: uppercase;
	letter-spacing: 1px;
	cursor: pointer;
	transition: background 0.25s;

	&:hover:not(:disabled) {
		background: #e55c00;
	}

	&:disabled {
		opacity: 0.65;
		cursor: not-allowed;
	}
`;

export const BtnFullLink = styled.a`
	display: block;
	width: 100%;
	padding: 12px;
	background: ${colorPrimary};
	color: #fff;
	border: none;
	border-radius: 4px;
	font-size: 14px;
	font-weight: 600;
	font-family: 'Poppins', sans-serif;
	text-transform: uppercase;
	letter-spacing: 1px;
	text-decoration: none;
	text-align: center;
	transition: background 0.25s;
	box-sizing: border-box;

	&:hover {
		background: #e55c00;
		color: #fff;
	}
`;

export const BtnPrimary = styled.a`
	display: inline-block;
	padding: 10px 28px;
	background: ${colorPrimary};
	color: #fff;
	border: none;
	border-radius: 4px;
	font-size: 13px;
	font-weight: 600;
	font-family: 'Poppins', sans-serif;
	text-transform: uppercase;
	letter-spacing: 1px;
	text-decoration: none;
	transition: background 0.25s;

	&:hover {
		background: #e55c00;
		color: #fff;
	}
`;

export const ErrorAlert = styled.div`
	background: #fff3f3;
	border: 1px solid #fcc;
	border-radius: 4px;
	padding: 10px 14px;
	color: #c00;
	font-size: 13px;
`;

/* ===== CONTACT SECTION ===== */
export const ContactSection = styled.section`
	padding: 60px 0;
	background: #292929;
`;

export const ContactInner = styled.div`
	max-width: 800px;
	margin: 0 auto;
	padding: 0 15px;
	text-align: center;
`;

export const ContactHeader = styled.div`
	margin-bottom: 30px;

	span {
		color: ${colorPrimary};
		font-size: 14px;
		text-transform: uppercase;
		letter-spacing: 1px;
	}

	h2 {
		color: #fff;
		font-size: 26px;
		font-weight: 300;
		margin: 10px 0 0;

		b {
			font-weight: 700;
		}
	}
`;

export const ContactForm = styled.div`
	display: flex;
	flex-direction: column;
	gap: 14px;
	margin-bottom: 20px;
`;

export const ContactRow = styled.div`
	display: flex;
	gap: 14px;

	@media (max-width: 767px) {
		flex-direction: column;
	}
`;

export const ContactInput = styled.input`
	flex: 1;
	padding: 12px 16px;
	border: 1px solid #444;
	border-radius: 4px;
	background: transparent;
	color: #fff;
	font-size: 14px;
	font-family: 'Poppins', sans-serif;
	outline: none;
	transition: border-color 0.25s;
	box-sizing: border-box;

	&::placeholder {
		color: #777;
	}

	&:focus {
		border-color: ${colorPrimary};
	}
`;

export const ContactTextarea = styled.textarea`
	width: 100%;
	padding: 12px 16px;
	border: 1px solid #444;
	border-radius: 4px;
	background: transparent;
	color: #fff;
	font-size: 14px;
	font-family: 'Poppins', sans-serif;
	outline: none;
	resize: vertical;
	min-height: 100px;
	transition: border-color 0.25s;
	box-sizing: border-box;

	&::placeholder {
		color: #777;
	}

	&:focus {
		border-color: ${colorPrimary};
	}
`;

export const ContactEmail = styled.div`
	margin-top: 20px;
	color: #777;
	font-size: 14px;

	i {
		color: ${colorPrimary};
		margin-right: 8px;
	}
`;

/* ===== FOOTER ===== */
export const FooterBar = styled.footer`
	background: #1a1a1a;
	padding: 20px 0;
`;

export const FooterInner = styled.div`
	max-width: 1170px;
	margin: 0 auto;
	padding: 0 15px;
	display: flex;
	align-items: center;
	justify-content: space-between;

	@media (max-width: 767px) {
		flex-direction: column;
		gap: 10px;
		text-align: center;
	}
`;

export const FooterCopy = styled.div`
	color: #777;
	font-size: 13px;
`;

export const FooterSocial = styled.ul`
	list-style: none;
	margin: 0;
	padding: 0;
	display: flex;
	gap: 16px;

	li a {
		color: #777;
		text-decoration: none;
		font-size: 13px;
		transition: color 0.2s;

		&:hover {
			color: ${colorPrimary};
		}

		i {
			margin-right: 4px;
		}
	}
`;

/* ===== SECTION HEADINGS ===== */
export const SectionHead = styled.div<{ $align?: 'left' | 'center'; $color?: string }>`
	text-align: ${({ $align }) => $align || 'center'};
	margin-bottom: 36px;
	padding-top: 0;

	span {
		color: ${({ $color }) => $color || colorPrimary};
		font-size: 14px;
		text-transform: uppercase;
		letter-spacing: 1px;
		display: block;
		margin-bottom: 8px;
	}

	h2 {
		font-size: 28px;
		font-weight: 300;
		color: #333;
		margin: 0;

		b {
			font-weight: 700;
		}
	}
`;
